import React, { useEffect, useMemo, useState } from "react";

const fieldError = (label) => `Completa el campo «${label}».`;

function NuevoSecretoModal({ open, onClose, clienteId, clienteNombre, tipos = [], ordenadores = [], onCreate, onCreated }) {
  const [scope, setScope] = useState("cliente");
  const [ordenadorId, setOrdenadorId] = useState("");
  const [tipo, setTipo] = useState("");
  const [titulo, setTitulo] = useState("");
  const [identificador, setIdentificador] = useState("");
  const [url, setUrl] = useState("");
  const [secreto, setSecreto] = useState("");
  const [notas, setNotas] = useState("");
  const [expiracion, setExpiracion] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const ordenadoresSorted = useMemo(() => [...(ordenadores || [])].sort((a, b) => String(a.descripcion || a.hostname || "").localeCompare(String(b.descripcion || b.hostname || ""), "es")), [ordenadores]);

  useEffect(() => {
    if (!tipo && tipos?.length) setTipo(String(tipos[0].value || ""));
  }, [tipo, tipos]);

  const resetAndClose = () => {
    if (saving) return;
    setScope("cliente"); setOrdenadorId(""); setTipo(tipos?.[0]?.value || ""); setTitulo(""); setIdentificador(""); setUrl(""); setSecreto(""); setNotas(""); setExpiracion(""); setError("");
    onClose?.();
  };

  const validate = () => {
    if (!clienteId) return "Selecciona primero un cliente.";
    if (!tipo) return fieldError("Tipo");
    if (!titulo.trim()) return fieldError("Título");
    if (!secreto.trim()) return fieldError("Contraseña / clave");
    if (scope === "equipo" && !String(ordenadorId || "").trim()) return "Selecciona el equipo al que pertenece la credencial.";
    return "";
  };

  const guardar = async (event) => {
    event?.preventDefault();
    const validationError = validate();
    if (validationError) { setError(validationError); return; }
    setSaving(true); setError("");
    try {
      await onCreate({ cliente_id: clienteId, ordenador_id: scope === "equipo" ? Number(ordenadorId) : null, tipo, titulo: titulo.trim(), identificador: identificador.trim(), url: url.trim(), secreto_plano: secreto, notas: notas.trim(), expiracion: expiracion || "" });
      onCreated?.();
    } catch (requestError) {
      setError(requestError?.response?.data?.error || requestError?.message || "No se pudo crear la credencial.");
    } finally { setSaving(false); }
  };

  if (!open) return null;
  return (
    <div className="modal-overlay credentials-edit-overlay" onMouseDown={(event) => event.target === event.currentTarget && resetAndClose()}>
      <form className="modal credentials-edit-modal credentials-create-modal" role="dialog" aria-modal="true" aria-labelledby="credentials-create-title" onSubmit={guardar}>
        <header className="modal-header credentials-edit-header">
          <div>
            <span className="credentials-edit-eyebrow">INVENTARIO SEGURO</span>
            <h3 id="credentials-create-title">Nueva credencial</h3>
            <p>{clienteNombre ? `Se guardará en ${clienteNombre}.` : "Crea un acceso global del cliente o asociado a un equipo."}</p>
          </div>
          <button className="button secondary small" type="button" onClick={resetAndClose} disabled={saving}>Cerrar</button>
        </header>
        <div className="modal-body credentials-edit-form">
          {error ? <div className="credentials-error" role="alert">{error}</div> : null}
          <section className="credentials-edit-section">
            <div className="credentials-edit-section-head"><h4>Identificación</h4><p>Indica dónde se utilizará esta credencial.</p></div>
            <div className="credentials-edit-grid">
              <label><span>Ámbito</span><select className="input" value={scope} onChange={(event) => { setScope(event.target.value); setError(""); }}><option value="cliente">Global del cliente</option><option value="equipo">Equipo concreto</option></select></label>
              <label><span>Tipo <em>Obligatorio</em></span><select className="input" value={tipo} onChange={(event) => { setTipo(event.target.value); setError(""); }}><option value="">Selecciona un tipo</option>{tipos.map((item) => <option key={item.value} value={item.value}>{item.label || item.value}</option>)}</select></label>
              {scope === "equipo" ? <label className="is-wide"><span>Equipo <em>Obligatorio</em></span><select className="input" value={ordenadorId} onChange={(event) => { setOrdenadorId(event.target.value); setError(""); }}><option value="">Selecciona un equipo…</option>{ordenadoresSorted.map((item) => <option key={item.id} value={item.id}>{item.descripcion || item.hostname || `Equipo #${item.id}`}</option>)}</select></label> : null}
              <label className="is-wide"><span>Título <em>Obligatorio</em></span><input className="input" autoFocus value={titulo} onChange={(event) => { setTitulo(event.target.value); setError(""); }} placeholder="Ej.: Administración Microsoft 365" /></label>
            </div>
          </section>
          <section className="credentials-edit-section credentials-access-section">
            <div className="credentials-edit-section-head"><h4>Acceso</h4><p>La clave se cifra antes de guardarse y nunca se muestra en el listado.</p></div>
            <div className="credentials-edit-grid">
              <label><span>Usuario / ID</span><input className="input" value={identificador} onChange={(event) => setIdentificador(event.target.value)} placeholder="Usuario, correo o identificador" /></label>
              <label><span>URL de acceso <em>Opcional</em></span><input className="input" type="url" value={url} onChange={(event) => setUrl(event.target.value)} placeholder="https://…" /></label>
              <label className="is-wide credentials-password-field"><span>Contraseña / clave <em>Obligatoria</em></span><input className="input" type="password" autoComplete="new-password" value={secreto} onChange={(event) => { setSecreto(event.target.value); setError(""); }} placeholder="Escribe la contraseña o clave…" /></label>
            </div>
          </section>
          <section className="credentials-edit-section">
            <div className="credentials-edit-section-head"><h4>Información adicional</h4><p>Datos internos que ayuden a utilizar el acceso correctamente.</p></div>
            <div className="credentials-edit-grid">
              <label><span>Caducidad <em>Opcional</em></span><input className="input" type="date" value={expiracion} onChange={(event) => setExpiracion(event.target.value)} /></label>
              <label className="is-wide credentials-notes-field"><span>Notas <em>Opcional</em></span><textarea className="input" rows="4" value={notas} onChange={(event) => setNotas(event.target.value)} placeholder="Añade instrucciones, 2FA, renovación u otra información útil…" /></label>
            </div>
          </section>
        </div>
        <footer className="modal-footer credentials-edit-footer"><button className="button secondary" type="button" onClick={resetAndClose} disabled={saving}>Cancelar</button><button className="button primary" type="submit" disabled={saving}>{saving ? "Guardando…" : "Crear credencial"}</button></footer>
      </form>
    </div>
  );
}

export default NuevoSecretoModal;
